import { BreakpointsMinQuery } from '@ab-core/breakpoints';
import { Colors, Shadows } from '@ab-core/colors';
import { RADIUS } from '@ab-core/radius';
import { SPACING } from '@ab-core/spacing';
import styled from 'styled-components';

export const ScalableProductContainer = styled.div`
    background: ${Colors.white};
    box-shadow: ${Shadows.componentShadow};
    padding: ${SPACING.SMALL_3};
    border-radius: ${RADIUS.MINIMAL};
    display: flex;
    flex-direction: column;
    gap: ${SPACING.SMALL};

    @media ${BreakpointsMinQuery.md} {
        padding: ${SPACING.MEDIUM};
        gap: ${SPACING.SMALL_3};
        &.ab-scalable-product-card-card-type-tile {
            height: 100%;
        }
    }
`;
